"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeMISC = function CategoryCodeMISC(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeMISC"), _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M5.035,3.884V2.976a.742.742,0,1,0-1.483,0v.908a2.314,2.314,0,0,1,1.483,0Z"
  }), _react.default.createElement("path", {
    d: "M4.294,8.457a2.336,2.336,0,0,1-.742-.122v4.689a.742.742,0,1,0,1.483,0V8.335A2.33,2.33,0,0,1,4.294,8.457Z"
  }), _react.default.createElement("path", {
    d: "M7.259,11.669v1.355a.741.741,0,1,0,1.482,0V11.669a2.311,2.311,0,0,1-1.482,0Z"
  }), _react.default.createElement("path", {
    d: "M8.741,7.218V2.976a.741.741,0,1,0-1.482,0V7.218a2.311,2.311,0,0,1,1.482,0Z"
  }), _react.default.createElement("path", {
    d: "M12.448,4.916V2.976a.742.742,0,1,0-1.483,0v1.94a2.314,2.314,0,0,1,1.483,0Z"
  }), _react.default.createElement("path", {
    d: "M10.965,9.367v3.657a.742.742,0,1,0,1.483,0V9.367a2.314,2.314,0,0,1-1.483,0Z"
  }), _react.default.createElement("circle", {
    cx: "4.294",
    cy: "6.11",
    r: "1.606"
  }), _react.default.createElement("circle", {
    cx: "8",
    cy: "9.443",
    r: "1.606"
  }), _react.default.createElement("path", {
    d: "M11.706,5.535A1.81,1.81,0,0,0,10.1,7.362a1.432,1.432,0,0,0,1.606,1.385,1.606,1.606,0,1,0,0-3.212Z"
  }))));
};

var _default = CategoryCodeMISC;
exports.default = _default;